module.exports = __webpack_public_path__ + "assets/img/banner2.d3cef0d6.png";